import { HeaderButton } from "@/src/components";
import { useBottomSheetModal } from "@gorhom/bottom-sheet";
import React from "react";

export function TodoBottomSheetMainHeaderLeft() {
  const bottomSheet = useBottomSheetModal();
  return (
    <HeaderButton
      paddingHorizontal={0}
      type="DONE"
      onPress={() => {
        bottomSheet.dismiss();
      }}
    />
  );
}
